module.exports = __webpack_public_path__ + "bfc69ff1d9085817e700094c1684d552.png";